import {inject, Injectable, Injector} from '@angular/core';
import {AppConfigService} from '../../services/config.service';
import {SYSTEM_STATUS_LOGGER_TOKEN} from '../system-status-indicator/system-status-logger';
import {AuthStreamingService} from './auth-streaming.service';
import {StreamingService, StreamingServiceConfig} from './streaming.service';
import {SubscriptionStreamingService} from './subscription-streaming.service';

@Injectable()
export class DistributedStreamingRegistryService {

    private static getStreamingServiceLogKeyCode(streamingApiName?: string): string {
        const DEFAULT_CODE = 'STR';
        const encodedStreamingApiName: string =
                  (streamingApiName || '')
                      .split('')
                      .reduce(
                          (acc, char, charIndex) =>
                              `${acc}${(!charIndex || /[A-Z]/.test(char)) ? char.toLocaleLowerCase() : ''}`,
                          ''
                      );

        return [
            DEFAULT_CODE,
            encodedStreamingApiName
        ].join('');
    }

    private defaultStreamingUrl = this.appConfigService.api['defaultStreaming'];

    private registry: {[streamingUrl: string]: Injector} = {};

    constructor(
        private appConfigService: AppConfigService,
        private injector: Injector
    ) {}

    public getStreamingServiceInjector(streamingApiName?: string): Injector {
        const streamingUrl = streamingApiName && this.appConfigService.api[streamingApiName]
            || this.defaultStreamingUrl;

        let injector = this.registry[streamingUrl];

        if (!injector) {
            injector = this.createStreamingServicesInjector(streamingUrl, streamingApiName);

            this.registry[streamingUrl] = injector;
        }

        return injector;
    }

    private createStreamingServicesInjector(streamingUrl: string, streamingApiName: string): Injector {
        const streamingServiceConfig: Partial<StreamingServiceConfig> = {
            socketUrl:              streamingUrl,
            systemStatusLogKeyCode: DistributedStreamingRegistryService.getStreamingServiceLogKeyCode(streamingApiName)
        };

        return Injector
            .create({
                name: `Streaming Services Injector`,
                parent: this.injector,
                providers: [
                    {
                        provide:    StreamingService,
                        useFactory: () =>
                                        new StreamingService(
                                            streamingServiceConfig,
                                            this.appConfigService,
                                            inject(SYSTEM_STATUS_LOGGER_TOKEN)
                                        )
                    },
                    AuthStreamingService,
                    SubscriptionStreamingService
                ]
            });
    }

}
